import { useState } from 'react';

/**
 * Hook personalizado para manejar la paginación de tablas
 * Reemplaza las funciones handleChangePage y handleChangeRowsPerPage repetidas
 * 
 * @param {number} initialPage - Página inicial (por defecto 0)
 * @param {number} initialRowsPerPage - Filas por página inicial (por defecto 25)
 * @returns {Object} Objeto con estado y funciones de paginación
 */
const usePagination = (initialPage = 0, initialRowsPerPage = 25) => {
  const [page, setPage] = useState(initialPage);
  const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);

  /**
   * Maneja el cambio de página
   * @param {Event} event - Evento del componente
   * @param {number} newPage - Nueva página
   */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  /**
   * Maneja el cambio de filas por página
   * @param {Event} event - Evento del componente
   */
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  /**
   * Resetea la paginación a los valores iniciales
   */
  const resetPagination = () => {
    setPage(initialPage);
    setRowsPerPage(initialRowsPerPage);
  };

  /**
   * Calcula los datos paginados
   * @param {Array} data - Array de datos a paginar
   * @returns {Array} Datos paginados
   */
  const getPaginatedData = (data) => {
    if (!Array.isArray(data)) return [];
    
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return data.slice(startIndex, endIndex);
  };

  return {
    // Estado
    page,
    rowsPerPage,
    
    // Funciones
    handleChangePage,
    handleChangeRowsPerPage,
    resetPagination,
    getPaginatedData,
    
    // Setters directos (por si se necesitan)
    setPage,
    setRowsPerPage
  };
};

export default usePagination;
